<div class="mb-42" style="height: 28px;">
  <div>
    <h3>{{ 'dashboard.revenue.title' | translate | titlecase }}</h3>
  </div>
</div>
<div
  style="height: calc( 100% - 70px );" class="mct-gap-40-gt-sm mct-grid-gt-sm mct-cols-1-1-gt-sm mct-grid-lt-md mct-cols-1-lt-md mct-gap-1rem-lt-md">
  <wl-dashboard-neo-revenue-dues-aging></wl-dashboard-neo-revenue-dues-aging>
  <wl-dashboard-neo-revenue-non-dues-aging></wl-dashboard-neo-revenue-non-dues-aging>
</div>